import { render, staticRenderFns } from "./RoundEmpty.vue?vue&type=template&id=0ba12886&scoped=true"
import script from "./RoundEmpty.vue?vue&type=script&lang=js"
export * from "./RoundEmpty.vue?vue&type=script&lang=js"
import style0 from "./RoundEmpty.vue?vue&type=style&index=0&id=0ba12886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba12886",
  null
  
)

export default component.exports